import React from "react";
import CctDetails from "../../components/editors/CctDetails";
import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../../navigations/RootNavigation";
import { useI18n } from "../../hooks/i18n-hooks";
import ScreenHeader from "./ScreenHeader";
import ScreenCard from "../ScreenCard";

type Props = StackScreenProps<RootStackParamList, "CctDetails">;

const CctDetailsScreen: React.FC<Props> = ({ route, navigation }) => {
    const i18n = useI18n();

    return (
        <>
            <ScreenHeader
                useSmallLabel
                onLeftAction={() => navigation.goBack()}
                label={i18n.t("screens.cct_details.title")}
            ></ScreenHeader>
            <ScreenCard>
                <CctDetails {...route.params} navigation={navigation} />
            </ScreenCard>
        </>
    );
};

export default CctDetailsScreen;
